import OpToken from "../../parser-tokens/OpToken";
import NearOpToken from "../../parser-tokens/NearOpToken";
import SearchParsingError from "../../errors/SearchParsingError";

const mWithinTokenRE = /^(w|within|pre)\/([1-9]\d*)$/;
const mLogSvc = new WeakMap();

class OpTokenFactory {
    constructor($log) {
        if ($log != null) {
            mLogSvc.set(this, $log);
        }
        else {
            throw new Error("Missing log service dependency");
        }
    }

    tryBuildToken(rawToken) {

        let lcRawToken = angular.lowercase(rawToken);

        if (lcRawToken === "and") {
            return new OpToken(mLogSvc.get(this), "and");
        }

        if (lcRawToken === "or") {
            return new OpToken(mLogSvc.get(this), "or");
        }

        if (lcRawToken === "not") {
            return new OpToken(mLogSvc.get(this), "not");
        }

        let withinTokenDistance = -1;

        let withinTokenReMatch = mWithinTokenRE.exec(rawToken);
        if (withinTokenReMatch != null) {

            withinTokenDistance = parseInt(withinTokenReMatch[2],10);
            if (!Number.isInteger(withinTokenDistance)) {
                throw new SearchParsingError("Within Token Distance Unexpectedly Not An Integer");
            }

            if (withinTokenDistance < 1) {
                throw new SearchParsingError("Within Token Distance Unexpected Less Than 1");
            }

            let withinOpOrdered = undefined;

            switch (withinTokenReMatch[1]) {
                case "w":
                    withinOpOrdered = false;
                    break;
                case "within":
                    withinOpOrdered = false;
                    break;
                case "pre":
                    withinOpOrdered = true;
                    break;
                default:
                    mLogSvc.get(this).error("Unexpected Within Token Ordering Value in String " + withinTokenReMatch[0]);
                    throw new SearchParsingError("Within Token Parsing Failure");
            }

            return new NearOpToken(mLogSvc.get(this), withinTokenDistance, withinOpOrdered);
        }

        return null;
    }

    buildToken(rawToken) {
        let opToken = this.tryBuildToken(rawToken);
        if (opToken == null) {
            throw new SearchParsingError("Invalid value for op token");
        }

        return opToken;
    }

}

OpTokenFactory.$inject = ["$log"];

export default OpTokenFactory;


//////////////////
// WEBPACK FOOTER
// ./src/models/factories/token-factories/OpTokenFactory.js
// module id = 1q7v
// module chunks = 1